<template>
  <div class="trainDetail">
    <div class="container">
      <div class="notice_title">
        <h3>{{ detail.video_name }}</h3>
        <p>发布时间：{{ detail.vidoe_time }}</p>
      </div>
      <div class="notice_content">
        {{ detail.content }}
        <video controls="controls" :src="baseurl + detail.video_url"></video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'trainDetail',
  data () {
    return {
      detail: {},
      baseurl: this.$baseurl
    }
  },
  mounted () {
    let { id } = this.$route.query
    this.getvideoDetail(id)
  },
  methods: {
    async getvideoDetail(id) {
      let { data: { code, data }} = await this.$http.get('video/selectOne', { params: { id }})
      if(code != 0) return
      this.detail = data 
    }
  }
}
</script>

<style lang="scss" scoped>
.trainDetail { 
    .notice_title {
    padding: 30px 0 10px;
    text-align: center;
    border-bottom: 1px solid #f4f4f5;
    h3 {
      font-size: 24px;
      font-weight: 500;
      line-height: 1.5;
    }
    p {
      font-size: 14px;
      line-height: 26px;
    }
  }
   .notice_content {
    padding: 20px 0;
    margin: auto;
    display: flex;
    justify-content: center;
    video {
      width: 50%;
      height: auto;  
    }
  }
}
</style>